import { Component, input, InputSignal } from '@angular/core';

@Component({
    selector: 'app-table-cell',
    templateUrl: './table-cell.component.html',
    standalone: true,
    host: {
        class: 'overflow-hidden bg-[var(--table-row-bg,var(--base-2))] group-hover:bg-[var(--table-row-bg-hover,var(--base-4))]',
        '[style.min-width]': 'minWidth()',
        '[class.sticky]': 'sticky()',
        '[class.left-0]': 'sticky()',
        '[class.z-10]': 'sticky()',
        '[class.-ml-8]': 'sticky()',
        '[class.pl-8]': 'sticky()',
        '[class.-my-3]': 'sticky()',
        '[class.self-stretch]': 'sticky()',
        '[class.flex]': 'sticky()',
        '[class.items-center]': 'sticky()',
        '[class.rounded-l-md]': 'sticky()'
    }
})
export class TableCellComponent {
    public width: InputSignal<string> = input('1fr');
    public minWidth: InputSignal<string> = input('100px');
    public sticky: InputSignal<boolean> = input(false);
}
